<button
  class="ag-action-icon-button"
  type="button"
  placement="top"
  container="body"
  tooltipClass="tooltip-info"
  [attr.data-id]="controlId + 'grid-action-btn-' + iconClass"
  [ngbTooltip]="tooltipText"
  [disableTooltip]="!tooltipText || disabled"
  [disabled]="disabled"
  (click)="onAction($event)"
>
  @if (numberOfAlerts > 0) {
    <span class="mr-1 color-red">{{ getNumberOfAlertsLabel  }}</span>
  }
  <i [class]="'icon ' + iconClass"></i>
</button>
